import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import { reaction, observable } from "mobx";
import DataWrapper from '../../principal/containers/DataWrapper';
import {Button, Row, Col, FormGroup, Label, Input} from 'reactstrap';
import {TabelaCadastro} from "../components/TabelaCadastro";
import Select from "react-select";
import ProdutoStore from "../stores/ProdutoStore";
import {
    arrayToString, createSelectOptions, formatarNomeProduto,
    listDiferencaByAtribute
} from "../../../utils/formatar";
import {
    getEscopoById, getMotivoContratacaoById, getSistemaAlocacaoById,
    sistemaAlocacaoEnum
} from "../../../utils/enums";
import {Validacao} from "../../comum/components/Validacao";

@inject("store")
@DataWrapper
@observer
export class CadastroProduto extends Component {
    constructor(props) {
        super(props);
        this.modal                      = this.props.store.modalStore;
        this.appStore                   = this.props.store.appStore;
        this.tituloPaginaStore          = this.props.store.tituloPaginaStore;
        /* Selecionar Controller */
        this.controller                 = new ProdutoStore(this.modal);
        this.nomeProdutoOptions         = [];
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Projeto/centro de resultado/finalidade");

        this.controller.carregarLista();

        this.sistemaAlocacaoOptions = createSelectOptions(sistemaAlocacaoEnum, "id", "valor");

    }

    /* modais (body e botões) */
    modalEditar = () => {
        const JustificativaDeContratacaoOptions = [];
        for(let i=0;i<this.controller.justificativaContratacoes.length;i++) {
            let nomeMotivo = getMotivoContratacaoById(this.controller.justificativaContratacoes[i].motivoContratacao);
            nomeMotivo = nomeMotivo ? nomeMotivo.valor : this.controller.justificativaContratacoes[i].motivoContratacao;
            JustificativaDeContratacaoOptions.push({value: this.controller.justificativaContratacoes[i].id, label: nomeMotivo + " - " + this.controller.justificativaContratacoes[i].nome})
        }

        return(
            <Row>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup check >
                        <Label check>
                            <Input type="checkbox" checked={this.controller.itemSelecionado.ativo} onChange={() => this.controller.toggleAtivo()}/>
                            <Label>Ativo</Label>
                        </Label>
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Projeto/centro de resultado/finalidade <sup>*</sup></Label>
                        <Input type="text" value={this.controller.itemSelecionado.nome + " (" + this.controller.itemSelecionado.codigo + ")"} readOnly/>
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Justificativa</Label>
                        <Select simpleValue  options={JustificativaDeContratacaoOptions} value={this.controller.itemSelecionado.justificativaContratacaoId}
                                onChange={(value) => this.controller.setJustificativaContratacaoId(value)} multi={false}
                                placeholder="Selecione..." noResultsText="Nenhum resultado encontrado" />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Descrição MOT</Label>
                        <Input type="textarea" value={this.controller.itemSelecionado.descricaoMot} onChange={(event) => this.controller.setDescricaoMot(event.target.value)}/>
                    </FormGroup>
                </Col>
            </Row>
        )
    };

    modalCadastrar = () => {
        const JustificativaDeContratacaoOptions = [];
        for(let i=0;i<this.controller.justificativaContratacoes.length;i++) {
            let nomeMotivo = getMotivoContratacaoById(this.controller.justificativaContratacoes[i].motivoContratacao);
            nomeMotivo = nomeMotivo ? nomeMotivo.valor : this.controller.justificativaContratacoes[i].motivoContratacao;
            JustificativaDeContratacaoOptions.push({value: this.controller.justificativaContratacoes[i].id, label: nomeMotivo + " - " + this.controller.justificativaContratacoes[i].nome})
        }
        return(
            <Row>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup check >
                        <Label check>
                            <Input type="checkbox" checked={this.controller.itemSelecionado.ativo} onChange={() => this.controller.toggleAtivo()}/>
                            <Label>Ativo</Label>
                        </Label>
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Projeto/centro de resultado/finalidade <sup>*</sup></Label>
                        <Select simpleValue isLoadingExternally={true} value={this.controller.itemSelecionado.codigo}
                                onChange={(value) =>  this.controller.setCodigo(value)}
                                searchPromptText="Informe nome para pesquisar" noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                asyncOptions={(input, callback) => this.controller.filtrarProdutos(input, callback)} />
                        <Validacao id="nome" valor={this.controller.itemSelecionado.codigo} tipo={["isRequired"]} />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Justificativa</Label>
                        <Select simpleValue  options={JustificativaDeContratacaoOptions} value={this.controller.itemSelecionado.justificativaContratacaoId}
                                onChange={(value) => this.controller.setJustificativaContratacaoId(value)} multi={false} placeholder="Selecione..." noResultsText="Nenhum resultado encontrado" />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Descrição MOT</Label>
                        <Input type="textarea" maxLength={512} value={this.controller.itemSelecionado.descricaoMot} onChange={(event) => this.controller.setDescricaoMot(event.target.value)}/>
                    </FormGroup>
                </Col>
            </Row>
        )
    };

    obterTituloMobile = (objeto) => {
        return objeto.nome;
    };

    obterConteudoMobile = (objeto) => {
        const ativo = objeto.ativo ? "Sim" : "Não";
        return (
            <div>
                { objeto.justificativaContratacao ? "Motivo de contratação: " + objeto.justificativaContratacao.motivoContratacao : null}<br/>
                { objeto.justificativaContratacao ? "Justificativa: " + objeto.justificativaContratacao.nome : null}<br/>
                { objeto.descricaoMot ? "Descrição MOT: " + objeto.descricaoMot : null}<br/>
                { "Sistema de alocação: " + getSistemaAlocacaoById(objeto.sistemaAlocacao).valor}<br/>
                { "Ativo: " + ativo}<br/>
            </div>
        )
    };

    produtoFormat = (cell, row) => {
        return cell && row.codigo ? cell + " (" + row.codigo +")" : cell ? cell : null;
    }

    nomesFormat(cell) {
        return cell ? cell.nome : ""
    }

    motivoContratacaoFormat(cell) {
        return cell ? getMotivoContratacaoById(cell.motivoContratacao).valor : ""
    }

    sistemaAlocacaoFormat(cell) {
        return getSistemaAlocacaoById(cell).valor
    }

    render() {
        /* Colunas da TabelaStore */
        const colunas = [
            {
                field: "nome",
                label: "Projeto/centro de resultado/finalidade",
                dataFormat: this.produtoFormat
            },{
                field: "justificativaContratacao",
                label: "Motivo de contratação",
                dataFormat: this.motivoContratacaoFormat
            },{
                field: "justificativaContratacao",
                label: "Justificativa",
                dataFormat: this.nomesFormat
            },{
                field: "descricaoMot",
                label: "Descrição MOT"
            },{
                field: "ativo",
                label: "Ativo",
                type: "boolean"
            }
        ];

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel panel-sm" : "panel-sm"}>
                        <TabelaCadastro
                            nomeCadastro={'Projeto/centro de resultado/finalidade'}
                            onChange={(value) => this.controller.setLista(value)}
                            listaItens={this.controller.produtoLista}
                            colunas={colunas}
                            temBusca={true}
                            criarNovos={false} // GM-126: Remover a funcionalidade de adicionar / excluir projetos/centros de resultado/finalidades
                            modalEditar={this.modalEditar()}
                            modalCadastrar={this.modalCadastrar()}
                            preencherModal={(row) => this.controller.preencherModal(row)}
                            editar={() => this.controller.editar()}
                            cadastrar={() => this.controller.cadastrar()}
                            remover={() => this.controller.remover()}
                            tituloMobile={(row) => this.obterTituloMobile(row)}
                            conteudoMobile={(row) => this.obterConteudoMobile(row)}
                            loading={this.controller.loading}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

